import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    bottom: '0',
    zIndex: 99999998,
    display: 'flex',
    justifyContent: 'space-evenly',
    boxShadow: '0px 5px 11px 3px rgba(0, 0, 0, 0.56)',
    width: '100%',
    padding: '1rem 0.5rem',
    backgroundColor: theme.palette.avatarBackground
  },

  icon: {
    height: '1rem',
    width: '1rem',
    border: `1.5px solid ${theme.palette.textLight}`,
    borderRadius: '100%',
    padding: '0.25rem',
    color: theme.palette.textLight,
    position: 'relative'
  },

  add: {
    position: 'absolute',
    transform: 'translateX(-75%) translateY(150%)',
    backgroundColor: theme.palette.avatarBackground,
    color: theme.palette.textLight,
    height: '0.75rem',
    width: '0.75rem'
  },

  quickAdd: {
    cursor: 'pointer'
  }
}))

export default useStyles
